<div class="grid" *ngIf="!isFunctionControlAccessSuppor()">
	<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
		<p-tag icon="pi cm-alert" [value]="('FUNCTION_NOT_SUPPORT' | translate)" severity="warning"></p-tag>
	</div>
</div>
<div class="grid" *ngIf="isFunctionControlAccessSuppor()">
	<div [class]="col6ResponsiveButtonLayout('left')">
		<p-button id="syncDataRbeAccessControl" label="{{ 'SYNC_DATA' | translate }}" (click)="syncData()"
			[disabled]="taskRunning || !online" icon="pi cm-cloud-sync" [rounded]="false" [text]="true" severity="warning"
			styleClass="font-bold border-yellow-600">
		</p-button>
	</div>
	<div [class]="col6ResponsiveButtonLayout('right')">
		<p-button label="{{ 'REMOVE_ALL' | translate }}" (click)="deleteAll()" icon="pi cm-trash"
			[disabled]="taskRunning || !online" [rounded]="false" [text]="true" severity="danger" styleClass="font-bold border-red-600">
		</p-button>
	</div>
</div>
<div *ngIf="acRbeSyncing">
	<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
		<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
	</div>
</div>
<p-accordion *ngIf="isFunctionControlAccessSuppor() && !acRbeSyncing">
	<app-control-access-group-easy-list></app-control-access-group-easy-list>
	<app-control-access-weekly-schedule-list></app-control-access-weekly-schedule-list>
	<app-control-access-special-planning-list></app-control-access-special-planning-list>
</p-accordion>
<p-confirmDialog #confDialog class="p-confirm-dialog-content">
	<ng-template pTemplate="footer">
		<div class="col-12 flex justify-content-center">
			<button type="button" pButton [label]="confDialog.acceptButtonLabel" [ngClass]="acceptButtonStyle"
				(click)="confDialog.accept()">
			</button>
			<button type="button" pButton [label]="confDialog.rejectButtonLabel" [ngClass]="rejectButtonStyle"
				(click)="confDialog.reject()">
			</button>
		</div>
	</ng-template>
</p-confirmDialog>